// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Qsehi","header":"_2s8z3","icon":"_2VPY_","technicalCode":"_1iDp3","body":"Cys4Z","title":"Kk88l","description":"_1CS2H","ccMessage":"IS9Le","button":"sYn_L"};